export const IconCheck = () => {
  return (
    <svg
      style={{ position: 'relative', left: '7rem' }}
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <foreignObject x='-4' y='-4' width='44' height='44'>
        <div
          style={{
            backdropFilter: 'blur(2px)',
            clipPath: 'url(#bgblur_0_17109_39994_clip_path)',
            height: '100%',
            width: '100%',
          }}
        >
          <div style={{ position: 'absolute', inset: 0 }} />
        </div>
      </foreignObject>
      <g data-figma-bg-blur-radius='4'>
        <rect width='36' height='36' rx='12' fill='black' fill-opacity='0.2' />
        <path
          d='M18 8C12.49 8 8 12.49 8 18C8 23.51 12.49 28 18 28C23.51 28 28 23.51 28 18C28 12.49 23.51 8 18 8ZM22.78 15.7L17.11 21.37C16.97 21.51 16.78 21.59 16.58 21.59C16.38 21.59 16.19 21.51 16.05 21.37L13.22 18.54C12.93 18.25 12.93 17.77 13.22 17.48C13.51 17.19 13.99 17.19 14.28 17.48L16.58 19.78L21.72 14.64C22.01 14.35 22.49 14.35 22.78 14.64C23.07 14.93 23.07 15.4 22.78 15.7Z'
          fill='#2DE200'
        />
      </g>
      <defs>
        <clipPath
          id='bgblur_0_17109_39994_clip_path'
          transform='translate(4 4)'
        >
          <rect width='36' height='36' rx='12' />
        </clipPath>
      </defs>
    </svg>
  );
};
